import React, { Fragment } from 'react';
import { useStyles } from './shapes.style';

interface FloatingProps {
	big?: string | undefined;
	small?: string | undefined;
}
const Floating = ({ big, small }: FloatingProps) => {
	const classes = useStyles();
	return (
		<Fragment>
			<img src={big} alt="" className={classes.big} />
			<img src={small} alt="" className={classes.small} />
		</Fragment>
	);
};

export default Floating;
